export default class rmRecipients {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/directives/rm-recipients.html'),
            scope: {
                tags: '=',
                segments: '=',
                subscribers: '=',
                showAll: '=',
                containerClass: '=',
                smaller: '='
            },
            controller: ['$scope', '$element', '$attrs', '$timeout', '$window', ($scope, $element, $attrs, $timeout, $window) => {
                var recipientTimeout;
                var roles = angular.fromJson($window.localStorage.getItem('roles'));

                $scope.showAllRecipients = false;
                $scope.ruler = (roles && roles.length && roles[0].name == "Ruler");

                $scope.recipientEnter = function() {
                    var labels, labelsWidth, labelsWrapper;
                    labelsWidth = 0;
                    labels = $($element).find('span.label');
                    labelsWrapper = $($element).find('.recipients-wrapper').width();

                    angular.forEach(labels, (label) => {
                        labelsWidth += $(label).outerWidth();
                    });

                    if (labelsWrapper < labelsWidth) {
                        recipientTimeout = $timeout(() => {
                            $scope.showAll = true;
                            $scope.$emit('recipient:toggle', true);
                        }, 700);
                    }
                };

                $scope.recipientLeave = function() {
                    if (recipientTimeout) {
                        $timeout.cancel(recipientTimeout);
                    }

                    $scope.showAll = false;
                    $scope.$emit('recipient:toggle', false);
                };
            }]
        }
    }    
};
